module.exports = function() {
  return new Worker(__webpack_public_path__ + "7ca74239f73b590b3d06.worker.js");
};